export class AttributeSearchModel {
  searchTerm: string;
  criteriaId: number;
  attributeCriteriaId: number;
  language: string;
}
